import {
  Identifier,
  QuestionViewPropsFor,
} from '@/components/question/view/types';
import { FlowColumn, QuestionTypeEnum } from '@/models/Question';
import {
  BANK_ID,
  Flow,
  Placement,
  SlotConfig,
} from '@/utils/questions/dnd/types';
import { useMemo, useState } from 'react';

export const SEQUENCE_SLOT_ID = 'sequence';

const slots: SlotConfig[] = [{ id: SEQUENCE_SLOT_ID, capacity: 'multiple' }];

export function useOrderingAnswerView(
  props: QuestionViewPropsFor<QuestionTypeEnum.DND_ORDENATION>,
) {
  const { question, value, mode } = props;
  const onChange = props.mode === 'answering' ? props.onChange : undefined;

  const column = question.columns.at(0);
  const items = column?.items ?? [];

  const tokens = items.map(item => ({ id: item.id, content: item }));

  const flow: Flow =
    column?.flow === FlowColumn.VERTICAL ? 'vertical' : 'horizontal';

  const [bankOrder, setBankOrder] = useState<Identifier[]>([]);

  const placement = useMemo<Placement>(
    () => ({ [SEQUENCE_SLOT_ID]: value ?? [], [BANK_ID]: bankOrder }),
    [value, bankOrder],
  );

  const disabled = mode !== 'answering';

  const handlePlacementChange = (next: Placement) => {
    setBankOrder(next[BANK_ID] ?? []);
    const sequence = next[SEQUENCE_SLOT_ID] ?? [];
    onChange?.(sequence.length ? sequence : null);
  };

  return { tokens, slots, flow, placement, handlePlacementChange, disabled };
}
